import { useQuery } from "@tanstack/react-query";
import { useAuth } from "zudoku/hooks";

export default function useGetTenantApplication(applicationId, tenantCode) {
  const apiAccessUrl = import.meta.env.ZUDOKU_PUBLIC_APIACCESSMANAGEMENT_FA_URL
  const subscriptionKey = import.meta.env.ZUDOKU_PUBLIC_SUBSCRIPTION_KEY

  const {providerData, isAuthenticated} = useAuth();
  const token = providerData?.accessToken || providerData?.idToken;

  return useQuery({
    retry: 5,
    enabled: !!tenantCode && !!token && isAuthenticated,
    queryKey: ['GET', `${apiAccessUrl}/${tenantCode}/applications/${applicationId}`],
    queryFn: async () => {
      const response = await fetch(`${apiAccessUrl}/${tenantCode}/applications/${applicationId}`, {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "Authorization": `Bearer ${token}`,
          "X-NBLY-Tenant-Code": tenantCode,
          "X-NBLY-Portal-Type": 'participant',
          "Ocp-Apim-Subscription-Key": subscriptionKey,
      },
      });

      if (!response.ok) {
        throw new Error('Failed to get tenant application');
      }

      return response.json();
    },
  });
}
